import React from 'react';
import { IconButton } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const renderButtonMenu = (toggleDrawer) => (
	<IconButton className="ml-10" onClick={toggleDrawer}>
		<span className="icon-nav-menu text-white" />
	</IconButton>
)

const HeaderApp = ({toggleDrawer, user}) => {
	let fullName = '';
	if (user && user.names) {
		if (user.names.length > 0 && user.firstSurname.length > 0 && user.lastSurname.length > 0) {
			fullName = `${user.names} ${user.firstSurname} ${user.lastSurname}`;
		}
	}

	return (
		<AppBar className="Dashboard-header">
		<Toolbar>
		{renderButtonMenu(toggleDrawer)}
		<Typography variant="title" color="inherit">
			Inspecciones vehiculares
		</Typography>
		<Typography variant="title" color="inherit" style={{ position: 'absolute', right: '2%'}}>
			<h6 style={{fontWeight: 100, marginBottom: 0, marginTop: '0'}}>{fullName}</h6>
		</Typography>
		</Toolbar>
	</AppBar>	
	)
};
export default HeaderApp;


// WEBPACK FOOTER //
// ./src/components/app/dashboard/chunks/header.js